import type { CloudMarketplace } from '../../../types/index'
import type { ViewResellerAuthorizationType } from '../../../modules/receivedResellerAuthorization/types'

export const getResellerAuthorizationFields = ({
  cloudMarketplace,
  resellerAuthorization,
}: {
  cloudMarketplace: CloudMarketplace
  resellerAuthorization: ViewResellerAuthorizationType
}) => {
  switch (cloudMarketplace) {
    case 'AWS':
      return {
        agreementName: resellerAuthorization?.agreementName,
        agreementDescription: resellerAuthorization?.agreementDescription,
        agreementDurationType: resellerAuthorization?.agreementDurationType,
      }
    case 'AZURE':
      return {
        agreementName: resellerAuthorization?.mppoName,
        agreementDescription: resellerAuthorization?.mppoDescription,
      }
    case 'GCP':
      return {}
    default:
      return {}
  }
}
